import { render, staticRenderFns } from "./Clickable.global.vue?vue&type=template&id=2dc86d9a&scoped=true&lang=pug&"
import script from "./Clickable.global.vue?vue&type=script&lang=ts&"
export * from "./Clickable.global.vue?vue&type=script&lang=ts&"
import style0 from "./Clickable.global.vue?vue&type=style&index=0&id=2dc86d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc86d9a",
  null
  
)

export default component.exports